import { hasNonDigitCharacters } from '../helpers/index.js';
import get from 'lodash/get';
import validBik from './valid-bik.js';
var INVALID_CHARACTERS_ERROR_MESSAGE = 'К/с может состоять только из цифр';
var validCorrespondentAccount = function validCorrespondentAccount(_a) {
  var _b = _a === void 0 ? {} : _a,
    _c = _b.message,
    message = _c === void 0 ? 'Введите правильный к/с' : _c,
    _d = _b.bikPath,
    bikPath = _d === void 0 ? 'bik' : _d,
    _e = _b.bikErrorMessage,
    bikErrorMessage = _e === void 0 ? 'Введите корректный БИК' : _e,
    _f = _b.bikEmptyMessage,
    bikEmptyMessage = _f === void 0 ? 'Отсутствует значение БИК. Введите его' : _f;
  return function (value, allValues) {
    if (value === void 0) {
      value = '';
    }
    if (allValues === void 0) {
      allValues = {};
    }
    var bik = get(allValues, bikPath);
    if (!bik) {
      return bikEmptyMessage;
    }
    if (validBik()(bik)) {
      return bikErrorMessage;
    }
    if (!value) {
      return message;
    }
    if (hasNonDigitCharacters(value)) {
      return INVALID_CHARACTERS_ERROR_MESSAGE;
    }
    if (value.length !== 20) {
      return message;
    }
    var controlString = (bik.substr(4, 2) + value).split('');
    var coefficients = [1, 3, 7, 1, 3, 7, 1, 3, 7, 1, 3, 7, 1, 3, 7, 1, 3, 7, 1, 3, 7, 1];
    var controlSum = controlString.reduce(function (sum, num, i) {
      var stringMultiplicationResult = (Number.parseInt(num, 10) * coefficients[i]).toString();
      var leastSignificantDigit = Number.parseInt(stringMultiplicationResult[stringMultiplicationResult.length - 1], 10);
      sum += leastSignificantDigit;
      return sum;
    }, 0).toString();
    var sumLeastSignificantDigit = controlSum[controlSum.length - 1];
    if (sumLeastSignificantDigit === '0') {
      return;
    }
    return message;
  };
};
export default validCorrespondentAccount;
export { INVALID_CHARACTERS_ERROR_MESSAGE, validCorrespondentAccount };